/* eslint-disable */ import { memoEval, sceneEntityObjectPropertiesComponent, sceneEntityRemoteObjectComponent } from '@salsita-ai/platform-project-sdk/domain';
import { attachComponent } from '../implementation.js';
export const legsNovaroComponents = [
    attachComponent.withComponent(sceneEntityRemoteObjectComponent, 'body', true).withAlias('LegsNovaro').attach(memoEval(()=>[], ()=>({
            fileUrl: '/models/algu3d.glb',
            objectName: 'NOVARO_SUPPORT',
            dimensionUnit: 'm'
        }))),
    attachComponent.withComponent(sceneEntityObjectPropertiesComponent, 'body', true).withAlias('LegsNovaro').attach(memoEval((self)=>[
            self.$height
        ], ($height)=>({
            morphTargetInfluences: {
                Height: {
                    value: $height,
                    scaleOne: 780,
                    scaleZero: 740
                }
            }
        })))
];

//# sourceMappingURL=legs-novaro.js.map